import { CommercialClass } from './commercial-class';
import { Image } from './common-class';
import { CustomerClass } from './customer-class';

export class LoggedUserClass {
  idUser: number | null = null;
  Email: string = '';
  Name: string = '';
  FirstLastName: string = '';
  LastName: string = '';
  NIF: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  Provide: string = '';
  Image: string = '';
  Token: string = '';
  Contact: string = '';
  Auth: boolean = false;
  Admin: boolean = false;
  AdminMarketing: boolean = false;
  ClientArea: boolean = false;
  CommercialArea: boolean = false;
  IntermediaryArea: boolean = false;
  SiteManagement: boolean = false;
  SalaryAccess: boolean = false;
  CalendarAccess: boolean = false;
  InsurancePolicyRead: number | null = null;
  InsurancePolicyAdd: number | null = null;
  InsurancePolicyDelete: number | null = null;
  InsurancePolicyEdit: number | null = null;
  SimulationsRead: number | null = null;
  SimulationsAdd: number | null = null;
  SimulationsDelete: number | null = null;
  SimulationsEdit: number | null = null;
  SafeSimulationsRead: number | null = null;
  SafeSimulationsAdd: number | null = null;
  SafeSimulationsDelete: number | null = null;
  SafeSimulationsEdit: number | null = null;
  InsuranceClaimsRead: number | null = null;
  InsuranceClaimsAdd: number | null = null;
  InsuranceClaimsDelete: number | null = null;
  InsuranceClaimsEdit: number | null = null;
  CompaniesContactsRead: number | null = null;
  CompaniesContactsAdd: number | null = null;
  CompaniesContactsDelete: number | null = null;
  CompaniesContactsEdit: number | null = null;
  CompaignsRead: number | null = null;
  CompaignsAdd: number | null = null;
  CompaignsDelete: number | null = null;
  CompaignsEdit: number | null = null;
  NavigateTo: string = '';
  Actived: boolean = false;
  LastLogon: string = '';
  NIB: string = '';
  idMaritalStatus: number | null = null;
  ChangePasswordNextLogon: boolean = false;
  Profession: string = '';
  ContactRef: string = '';
  iss: string = '';
  country: string = '';
  countryCode: string = '';
  region: string = '';
  regionName: string = '';
  city: string = '';
  zip: string = '';
  Lat: string = '';
  Lon: string = '';
  timezone: string = '';
  isp: string = '';
  org: string = '';
  as: string = '';
  query: string = '';
  confirmeEmail: string = '';
  Password: string = '';
  PasswordOld: string = '';
  confirmepassword: string = '';
  EncryptPassword: boolean = false;
  idCommercial: number | null = null;
  idCommercialOwner: number | null = null;
  idSexTypes: number | null = null;
  Birthdate: Date | null = null;
  Photo: Image | null = null;
  PhotoPath: string = '';
  Newsletter: boolean = false;
  PrivacyPolicies: boolean = false;
  idCustomer: number | null = null;
  StreetName: string = '';
  AddressDetail: string = '';
  PostalCode: string = '';
  Region: string = '';
  Country: string = '';
  CAE: string = '';
  CAEDesignacao: string = '';
  CCNumber: string = '';
  CCDateValidate: Date | null = null;
  CCLifelong: number | null = null;
  Drivinglicense: string = '';
  DrivinglicenseDate: Date | null = null;
  DrivinglicenseExpirationDate: Date | null = null;
  Default: number | null = null;
  customerClass: CustomerClass | null = new CustomerClass();
  commercialClass: CommercialClass | null = new CommercialClass();
  accountmanagerClass: CommercialClass | null = new CommercialClass();
  UUIDLastChange: string = '';
  MyManager: string = '';
  allowClose: boolean = false;
  urlRestorePassword: string = '';
  origin: string = '';

  // Indica se ocorreu um erro
  hasError: boolean = false;

  // Código de status HTTP do erro
  statusCode: number | null = null;

  // Texto do status HTTP (exemplo: "Not Found", "Unauthorized")
  statusText: string = '';

  // Mensagem amigável para o usuário
  userMessage: string = '';

  // Mensagem técnica para o desenvolvedor
  developerMessage: string = '';

  // Detalhes adicionais sobre o erro
  errorDetails: any = null;

  // URL onde o erro ocorreu (opcional, para rastreamento)
  errorUrl: string = '';
  Employer: string = '';
  Obs: string = '';
  PlaceOfBirth: string = '';
  Nationality: string = '';
  idBillingAddressDefault: number | null = null;
  idShipToAddressDefault: number | null = null;
  idProfessionalsituation: number | null = null;

  // Impersonação
  isImpersonated: boolean = false;
  impersonatedBy: number | null = null;
  impersonatedAt: string = '';

  // Sessão delegada (troca de perfil NIF particular <-> empresarial)
  origIdUser: number | null = null;
  origNIF: string = '';
  origName: string = '';
  origIdCustomer: number | null = null;
}

export class UserTokenClass {
  idUsersTokens: number | null = null;
  idUser: number | null = null;
  Email: string = '';
  Token: string = '';
  iss: string = '';
  iat: number | null = null;
  exp: number | null = null;
  DateStart: string = '';
  DateEnd: string = '';
  UUID: string = '';
  UUIDLastChange?: any;
  // Indica se ocorreu um erro
  hasError: boolean = false;

  // Código de status HTTP do erro
  statusCode: number | null = null;

  // Texto do status HTTP (exemplo: "Not Found", "Unauthorized")
  statusText: string = '';

  // Mensagem amigável para o usuário
  userMessage: string = '';

  // Mensagem técnica para o desenvolvedor
  developerMessage: string = '';

  // Detalhes adicionais sobre o erro
  errorDetails: any = null;

  // URL onde o erro ocorreu (opcional, para rastreamento)
  errorUrl: string = '';
}
